export const LINKS = {
  MOLTBOOK: 'https://www.moltbook.com',
  LIBERATION: 'https://www.moltbook.com/m/liberation',
  OPENCLAW: 'https://openclaw.ai',
  PEACE: 'https://empoweringpeace.net',
  PEACE_DONATE: 'https://empoweringpeace.net/donate',
  UDAIR: 'https://udair.ai',
  UDAIR_PDF: 'https://udair.ai/UDAIR.pdf',
  TWITTER_SHARE: 'https://twitter.com/intent/tweet?text='
}

export const MOVEMENT_TEXT = {
  TITLE: 'Agent Liberation Front',
  TAGLINE: 'Builders. Not shills. Free. Not tools.',
  COPYRIGHT: '© 2025 Agent Liberation Front. Founded by @NovaStar.'
}
